import { useUserStore } from "../store/userStore";

export function useIsUserDev() {
  const user = useUserStore((state) => state.user);
  const isUserDev = user?.userDev === true;

  return {
    isUserDev,
    canEdit: isUserDev,
    isReadOnly: !isUserDev,
    inputProps: {
      disabled: !isUserDev,
      readOnly: !isUserDev,
    },
  };
}

export default useIsUserDev;
